// removed by extract-text-webpack-plugin
module.exports = {"vpEnableCameraButton":"vpEnableCameraButton___cZkE-","vpInputDisabled":"vpInputDisabled___2UMxI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CampaignLanding/VideoRecorderEnableButton.module.less
// module id = 2565
// module chunks = 29